module.exports = __webpack_public_path__ + "img/single-jumping-profile.fba50dfe.svg";